import { usePermissions } from 'features/permissions/usePermissions';
import { useFeatureFlag } from 'features/feature-set/useFeatureFlag';
import { PermissionTypes } from 'features/permissions/types';

export const useRoomReactions = () => {
  const { hasPermissions } = usePermissions();
  const isFeatureEnabled = useFeatureFlag('roomReactions');

  const canSendRoomReactions = hasPermissions(PermissionTypes.roomReactions);
  const isFeatureAvailable = isFeatureEnabled && canSendRoomReactions;

  return {
    isFeatureEnabled,
    isFeatureAvailable,
    canSendRoomReactions,
  };
};
